import { jsx as _jsx } from "react/jsx-runtime";
import { createTheme, ThemeProvider } from '@mui/material/styles';
export const pdf_theme = createTheme({
    typography: {
        button: {
            textTransform: 'none',
        },
        body1: {
            fontSize: 12,
        },
        h6: {
            textTransform: 'none',
            fontSize: 12,
            fontWeight: 600,
        },
        h5: {
            fontSize: 16,
        },
    },
    components: {
        MuiDivider: {
            defaultProps: {
                sx: {
                    borderBottom: '2px solid #c5c5c5',
                    marginY: 1,
                },
            },
        },
    },
    palette: {
        primary: {
            light: '#DE7A4B',
            main: '#D6591F',
            dark: '#953E15',
            contrastText: '#fff',
        },
        secondary: {
            light: '#5f6467',
            main: '#383E42',
            dark: '#272B2E',
            contrastText: '#fff',
        },
    },
});
export default function SBPDFThemeProvider({ children }) {
    return _jsx(ThemeProvider, Object.assign({ theme: pdf_theme }, { children: children }));
}
